import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../locales/translations';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { scrollToElement, scrollWindowToTop } from '../lib/scroll';
import { LOGO_URL } from '../assets/index';

const Footer = () => {
  const { language } = useLanguage();
  const text = t[language].footer;

  const navLinks = [
    { id: 'features', label: t[language].nav.features },
    { id: 'pricing', label: t[language].nav.pricing },
    { id: 'testimonials', label: t[language].nav.testimonials },
    { id: 'faq', label: t[language].nav.faq },
  ];

  return (
    <footer className="bg-[#0a0a0f] pt-12 pb-8 border-t border-white/10">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-10">
          <motion.div
            className="flex items-center justify-center gap-2 cursor-pointer"
            onClick={() => scrollWindowToTop()}
            whileHover={{ scale: 1.05 }}
            transition={{ type: 'spring', stiffness: 400 }}
          >
            <img src={LOGO_URL} alt="LovaGO" className="w-8 h-8 object-contain" />
            <span className="text-xl font-black bg-clip-text text-transparent bg-gradient-to-r from-orange-500 via-pink-500 to-purple-600">
              LovaGO
            </span>
          </motion.div>

          <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToElement(link.id)}
                className="text-gray-500 hover:text-white text-sm transition-colors"
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 mb-8 text-orange-500">
          <a href="https://wa.me/5565999496565" target="_blank" rel="noopener noreferrer" className="hover:text-orange-400 transition-colors" aria-label="WhatsApp">
            <SafeIcon icon={FiIcons.FiMessageCircle} className="text-2xl" />
          </a>
          <a href="mailto:lovago@lovago.net" className="hover:text-orange-400 transition-colors" aria-label="Email">
            <SafeIcon icon={FiIcons.FiMail} className="text-2xl" />
          </a>
        </div>

        <div className="border-t border-white/5 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4 text-center">
          <p className="text-gray-600 text-xs sm:text-sm">{text.rights}</p>
          <a 
            href="https://wa.me/5565999496565" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-orange-500 hover:text-orange-400 transition-colors font-bold text-xs sm:text-sm flex items-center justify-center gap-2"
          >
            <SafeIcon icon={FiIcons.FiMessageCircle} /> {text.disclaimer}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;